import { cnpjNumber } from '../common/validations/social';
import decimalComma from '../common/validations/decimal';
import moneyRequired from '../common/validations/money-required';
import moneyMax from '../common/validations/money-max';
import dataVal from '../common/validations/time';

const messages = {
  moneyrequired: () => 'Este campo é obrigatório',
  moneymax: () => 'Excedeu o valor disponível.',
  required: () => 'Este campo é obrigatório',
  email: () => 'Este email é inválido',
  digits: (value, args) => `Campo numérico com ${args} dígitos obrigatórios`,
  decimalcomma: (value, args) => `Máximo de ${args} casas decimais`,
  min_value: (value, args) => `Mínimo de ${args} caracteres`,
  max: (value, args) => `Máximo de ${args} dígitos`,
  numeric: () => 'Este campo aceita apenas números',
};

const dictionary = {
  en: {
    messages,
  },
  pt: {
    messages,
  },
  ptbr: {
    messages,
  },
};

export default (Validator) => {
  // Exemplo de como usar um validator customizado
  Validator.extend('cnpj', cnpjNumber);
  Validator.extend('decimalcomma', decimalComma);
  Validator.extend('dateformat', dataVal);
  Validator.extend('moneyrequired', moneyRequired);
  Validator.extend('moneymax', moneyMax);
  Validator.updateDictionary(dictionary);
};



// WEBPACK FOOTER //
// ./src/config/validations.js